// extracted by mini-css-extract-plugin
module.exports = {"container":"category-cards_container__24v_v"};